import Vue from 'vue'
import Vuex from 'vuex'
import reinstall from './reinstall'
import saas from './saas'
import ncstock from './ncstock'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const plugins = debug ? [createLogger()] : []

export default new Vuex.Store({
  modules: {
    reinstall,
    saas,
    ncstock
  },
  strict: debug,
  plugins: plugins
})
